import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'map',
    path: '/map',
    component: () => import('../pages/MapPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
